/*
  made.straps video row: pause control.

  Companion to blocks/ms-video-row.liquid.

  Two jobs, both accessibility rather than decoration:

  1. A pause button. WCAG 2.2.2 says anything that moves automatically for
     more than five seconds must be stoppable. Motion in the corner of the
     eye is genuinely disabling for some people, and a looping video never
     stops on its own.

  2. Honour prefers-reduced-motion. If the operating system has been told
     to reduce motion, the video starts paused and the button offers Play
     instead. We do not override that choice on their behalf.

  The button reports state with aria-pressed and swaps its own label, so it
  works the same whether you can see the video or not.
*/
(function () {
  'use strict';

  if (window.__msVideoRow) return;
  window.__msVideoRow = true;

  var PAUSE = 'Pause';
  var PLAY = 'Play';

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function videoIn(cell) {
    return cell.querySelector('video');
  }

  function setState(cell, paused) {
    var btn = cell.querySelector('[data-ms-vrow-pause]');
    var label = cell.querySelector('[data-ms-vrow-pause-label]');
    if (!btn) return;
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    if (label) label.textContent = paused ? PLAY : PAUSE;
  }

  function init(cell) {
    if (cell.dataset.msVrowReady === 'true') return;
    var v = videoIn(cell);
    if (!v) return;
    cell.dataset.msVrowReady = 'true';

    // Shopify's video_tag writes the label we want to restore later.
    var label = cell.querySelector('[data-ms-vrow-pause-label]');
    if (label && label.textContent.trim()) PAUSE = label.textContent.trim();

    if (reduceMotion()) {
      v.autoplay = false;
      v.pause();
      setState(cell, true);
    } else {
      setState(cell, false);
    }

    // Keep the button honest if playback changes for any other reason,
    // for example the browser refusing to autoplay.
    v.addEventListener('pause', function () { setState(cell, true); });
    v.addEventListener('play', function () { setState(cell, false); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-ms-vrow-pause]');
    if (!btn) return;
    var cell = btn.closest('[data-ms-vrow-video]');
    if (!cell) return;
    var v = videoIn(cell);
    if (!v) return;

    e.preventDefault();
    if (v.paused) {
      var p = v.play();
      if (p && p.catch) p.catch(function () { setState(cell, true); });
    } else {
      v.pause();
    }
  });

  function initAll() {
    var cells = document.querySelectorAll('[data-ms-vrow-video]');
    for (var i = 0; i < cells.length; i++) init(cells[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Sections re-render in the theme editor and on some navigations.
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; initAll(); }, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();